module.exports = __webpack_public_path__ + "img/download_pc.85046fce.png";